export interface IActiveDirectoryConsentDraft {
  tenantId?: string;
  email?: string;
  title?: string;
}

const key = (clientId: string) => `active-directory-app-only-draft:${clientId}`;

/**
 * The form while the admin is at Microsoft, as in `Outlook/consentDraft.ts`.
 * Storage can throw (private window); then the fields are simply retyped.
 */
export const saveConsentDraft = (
  clientId: string,
  draft: IActiveDirectoryConsentDraft,
) => {
  try {
    window.localStorage.setItem(key(clientId), JSON.stringify(draft));
  } catch {
    // the form still works, it is just not refilled
  }
};

export const readConsentDraft = (
  clientId: string,
): IActiveDirectoryConsentDraft | null => {
  try {
    const raw = window.localStorage.getItem(key(clientId));

    return raw ? (JSON.parse(raw) as IActiveDirectoryConsentDraft) : null;
  } catch {
    return null;
  }
};

export const clearConsentDraft = (clientId: string) => {
  try {
    window.localStorage.removeItem(key(clientId));
  } catch {
    // see above
  }
};
